import script from "./EmployeeCard.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeCard.vue?vue&type=script&setup=true&lang=js"

import "./EmployeeCard.vue?vue&type=style&index=0&id=5cbc0a1a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cbc0a1a"]])

export default __exports__